module.exports = __webpack_public_path__ + "img/ic-clear.980132d2.svg";